import { gql } from '@apollo/client'

export const GET_LIVESTREAMS_BY_PROJECT = gql`
  query getLivestreamsByProject($projectSlug: String!) {
    project(slug: $projectSlug) {
      id
      livestreams(includeGuildOnly: true) {
        projectSlug
        name
        bannerCloudinaryPath
        id
        guid
        live
        isEnded
        startAt
        unavailableReason
      }
    }
  }
`
